module.exports = __webpack_public_path__ + "static/media/xtimelogo.105f7cb1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/components/ContentFooter/xtimelogo.svg
// module id = 1712
// module chunks = 7